<template>
  <v-card>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-text-field
              prepend-icon="flash_on"
              label="Email do Cliente"
              v-model="email"
            />
          </v-flex>

          <v-flex xs12 md2>
            <v-text-field
              v-model="holder_doc"
              label="CPF/CNPJ"
              prepend-icon="event"
              class="purple-input"
              @keyup.enter="validate"
              mask="###.###.###-##"
            />
          </v-flex>
          <v-flex xs12 md4 class="text-lg-right">
            <v-btn
              color="warning"
              @click="clear()"
              :disabled="loadingInvoices"
              :loading="loadingInvoices"
              small
              outline
              slot="start"
            >
              <v-icon>close</v-icon>
              Limpar
            </v-btn>
            <v-btn
              color="primary"
              @click="validate()"
              :disabled="loadingInvoices"
              :loading="loadingInvoices"
              small
              outline
              slot="start"
            >
              <v-icon>search</v-icon>Buscar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      email: null,
      holder_doc: null,
      valid: false,
    };
  },

  computed: {
    ...mapState("billing", ["loadingInvoices"]),
  },

  methods: {
    ...mapActions("billing", ["getAllBillingsByClient"]),

    async validate() {
      if (this.$refs.form.validate()) {
        if (!this.email && !this.holder_doc) {
          return true;
        }
        const params = {
          email: this.email,
          holder_doc: this.holder_doc,
        };
        await this.getAllBillingsByClient(params);
      }
    },
    clear() {
      this.email = null;
      this.holder_doc = null;
      this.valid = false;
      this.$store.commit("billing/setMergingInvoices", []);
    },
  },
};
</script>
